<template>
	<div class="footprint">
		<div class="block" v-for="(item,index) in commodity" :key="index">
			<div class="block-title">
				{{item.time}}
			</div>
			<div class="commodity-block">
				<commodity v-for="(tab,tabIndex) in item['tabs']" :key="tabIndex" :node="tab"></commodity>
			</div>
		</div>
		<ul class="empty" v-if="commodity.length == 0">
			<el-empty></el-empty>
		</ul>
	</div>
</template>

<script>
	export default {
		name: 'footprint',
		data() {
			return {
				commodity: [],
				keyword: '',
				currentPage: 1
			};
		},
		watch: {
			getKeyword(keyword) {
				this.keyword = keyword
				this.fetchData()
			}
		},
		computed: {
			getKeyword() {
				return this.$store.state.spaceKeyword
			}
		},
		methods: {
			fetchData() {
				this.$api.frontViewList({
					pageSize: 6,
					pageNum: this.currentPage,
					memberId: this.$store.state.userinfo.userId,
					lotName: this.keyword
				}, res => {
					if (res.code == 200) {
						let list = res.data.list
						let array = new Array()
						for (let i = 0; i < list.length; i++) {
							let flow = new Array()
							if(list[i].length>0){
								let node = list[i][1]
								for (let k = 0; k < node.length; k++) {
									let transTime = ''
									if (node[k].auctionStatus == 1) {
										transTime = node[k]['startTime']
									} else {
										transTime = node[k]['endTime']
									}
									let diff = this.$pub.timeStampDifferene(transTime)
									flow.push({
										image: node[k]['lotPictrueUrl'],
										name: node[k]['lotName'],
										now: !node[k]['currentPrice'] ? node[k]['startPrice'] : node[k][
											'currentPrice'
										],
										number: !node[k]['biddingCount'] ? 0 : node[k][
											'biddingCount'
										],
										evaluated: node[k]['evaluationPrice'],
										day: diff.day,
										timeStr: diff.h + ':' + diff.m + ':' + diff.s,
										view: !node[k]['watchFrequency'] ? 0 : node[k][
											'watchFrequency'
										],
										people: !node[k]['enrollNumber'] ? 0 : node[k][
											'enrollNumber'
										],
										status: node[k]['auctionStatus'],
										id: node[k]['id']
									})
								}
								let obj = {
									time: list[i][0],
									tabs: flow
								}
								array.push(obj)
							}
						}
						if (this.currentPage == 1) {
							this.commodity = array
						} else {
							this.commodity = this.commodity.concat(array)
						}
						this.totalPage = Math.ceil(res.data.total / 6)
					}
				})
			},
			pageScroll() {
				if (this.currentPage == this.totalPage) {
					return
				}
				let scrollTop = document.documentElement.scrollTop
				let scrollHeight = document.documentElement.scrollHeight
				let clientHeight = document.documentElement.clientHeight
				if (scrollTop + clientHeight - scrollHeight >= 0) {
					console.log("页面到底");
					this.currentPage++;
					//滚动至底部后请求数据
					this.fetchData();
				}
			}
		},
		beforeCreate: function() {
			//生命周期 -- 组件实例刚被创建，组件属性计算之前，如DATA属性等
		},
		created: function() {
			//生命周期 -- 组件实例创建完成，属性已绑定，但DOM还未生成，$el属性还不存在
		},
		beforeMount: function() {
			//模板编译/挂载之前
		},
		mounted: function() {
			//模板编译/挂载之后
			this.fetchData()
			window.onscroll = this.pageScroll
		},
		beforeUpdate: function() {
			//组件更新之前
		},
		updated: function() {
			//组件更新之后
		},
		activated: function() {
			// for keep-alive，组件被激活时调用
		},
		deactivated: function() {
			// for keep-alive，组件被移除时调用
		},
		beforeDestory: function() {
			// 组件销毁调用
		},
		destoryed: function() {
			// 组件销毁后调用
		}
	};
</script>

<style lang="less" scoped="scoped">
	.block {
		width: 100%;

		.block-title {
			width: 100%;
			height: 50px;
			display: flex;
		}
	}
</style>
